import firebase from 'firebase/app'

export default function(_this) {
  return {
    log(val) {
      val.date = firebase.database.ServerValue.TIMESTAMP
      val.userId = fbUser.uid
      val.userEmail = fbUser.email
      return new Promise(resolve => {
        _this.getRef('dataGridLogs').push(val, () => resolve())
      })
    },
  }
}
